const translation = {
  nav: {
    home: "Strona Główna",
    categories: "Kategorie",
    spreadsheet: "Spreadsheet",
    safety: "Bezpieczeństwo",
    guides: "Poradniki",
    buyingGuide: "Poradnik Zakupowy",
    faq: "FAQ",
  },
  hero: {
    title: "Kakobuy Spreadsheet Polska – Największa Baza Znalezisk i Linków",
    subtitle: "Znajdź najlepsze produkty Kakobuy w jednym miejscu. Sprawdzaj popularne linki, porównania, zdjęcia QC oraz aktualny Kakobuy Spreadsheet.",
    cta1: "Kakobuy Spreadsheet",
    cta2: "Buy It Now",
    badge1: "Aktualizowane listy produktów",
    badge2: "Przewodniki zakupowe",
    badge3: "Porównania jakości",
    badge4: "Bezpieczne wskazówki",
  },
  categories: {
    title: "Popularne Kategorie Kakobuy Spreadsheet",
    subtitle: "Przeglądaj nasze starannie wyselekcjonowane kategorie produktów i znajdź dokładnie to, czego szukasz.",
    shoes: "Buty",
    hoodies: "Bluzy / Swetry",
    tshirts: "Koszulki",
    jackets: "Kurtki",
    pants: "Spodnie / Szorty",
    headwear: "Nakrycia Głowy",
    sets: "Zestawy",
    underwear: "Bielizna",
    jersey: "Koszulki Sportowe",
    accessories: "Akcesoria",
    bags: "Torby",
    belts: "Paski",
    perfumes: "Perfumy",
    other: "Inne Produkty",
  },
  about: {
    title: "Czym jest Kakobuy Spreadsheet?",
    intro: "Kakobuy Spreadsheet to kompleksowa baza danych produktów, która pomaga użytkownikom platformy Kakobuy w szybkim odnajdywaniu najlepszych ofert. Zamiast przeszukiwać setki stron i aukcji, użytkownicy mogą skorzystać z gotowego arkusza kalkulacyjnego zawierającego starannie wyselekcjonowane linki do produktów, zdjęcia kontroli jakości (QC) oraz opinie społeczności.",
    methodTitle: "Metody Wyszukiwania Produktów",
    tableMethod: "Metoda",
    tableAdvantages: "Zalety",
    tableDisadvantages: "Wady",
    tableFor: "Dla kogo",
    method1: "Ręczne przeszukiwanie",
    method1Adv: "Pełna kontrola nad wyborem",
    method1Dis: "Bardzo czasochłonne, trudne dla początkujących",
    method1For: "Doświadczeni użytkownicy z dużą ilością czasu",
    method2: "Kakobuy Spreadsheet",
    method2Adv: "Szybki dostęp do sprawdzonych linków, oszczędność czasu",
    method2Dis: "Ograniczone do produktów w arkuszu",
    method2For: "Każdy użytkownik – od początkującego do zaawansowanego",
    method3: "Wyszukiwanie obrazem",
    method3Adv: "Możliwość znalezienia konkretnego produktu",
    method3Dis: "Wymaga dobrej jakości zdjęcia, nie zawsze skuteczne",
    method3For: "Użytkownicy szukający konkretnych modeli",
  },
  benefits: {
    title: "Dlaczego warto korzystać z Kakobuy Spreadsheet?",
    subtitle: "Odkryj korzyści płynące z korzystania z naszego arkusza kalkulacyjnego i przyspiesz swoje zakupy na Kakobuy.",
    benefit1Title: "Lepsze odkrywanie produktów",
    benefit1Desc: "Znajdź ukryte perełki i popularne produkty, które zostały już przetestowane i ocenione przez społeczność Kakobuy.",
    benefit2Title: "Rekomendacje społeczności",
    benefit2Desc: "Korzystaj z doświadczeń innych użytkowników. Każdy produkt w arkuszu został zweryfikowany pod kątem jakości i zgodności z opisem.",
    benefit3Title: "Porównywanie cen",
    benefit3Desc: "Łatwo porównuj ceny różnych sprzedawców oferujących podobne produkty i wybieraj najlepsze oferty dostępne na platformie.",
    benefit4Title: "Weryfikacja sprzedawców",
    benefit4Desc: "Unikaj nieuczciwych sprzedawców dzięki systemowi ocen i recenzji. Arkusz zawiera tylko sprawdzone i zaufane źródła.",
  },
  safety: {
    title: "Czy Kakobuy Spreadsheet jest bezpieczny?",
    subtitle: "Poznaj najważniejsze zasady bezpiecznych zakupów i dowiedz się, jak unikać potencjalnych zagrożeń podczas korzystania z platformy.",
    problemTitle: "Problem",
    solutionTitle: "Rozwiązanie",
    problem1: "Fałszywe linki do produktów",
    solution1: "Weryfikacja sprzedawcy – sprawdzaj oceny, historię i recenzje przed zakupem",
    problem2: "Niska jakość produktów",
    solution2: "Kontrola QC – zawsze proś o zdjęcia kontroli jakości przed wysyłką",
    problem3: "Nieprawidłowe rozmiary",
    solution3: "Tabele rozmiarów – korzystaj z tabel rozmiarów i opinii innych kupujących",
    problem4: "Problemy z wysyłką",
    solution4: "Ubezpieczenie przesyłki – wybieraj opcje wysyłki z ubezpieczeniem i śledzeniem",
  },
  article: {
    title: "Najnowsze Poradniki Kakobuy",
    subtitle: "Przeczytaj nasze szczegółowe artykuły i poradniki, które pomogą Ci w pełni wykorzystać potencjał platformy Kakobuy.",
    readMore: "Czytaj więcej",
    article0Title: "Kompletny Przewodnik po Kakobuy Spreadsheet",
    article0Desc: "Dowiedz się wszystkiego o Kakobuy Spreadsheet – od podstaw po zaawansowane techniki wyszukiwania produktów. Oszczędź czas i pieniądze.",
    article1Title: "Czy Kakobuy jest bezpieczny? Kompletny poradnik",
    article1Desc: "Wszystko o bezpieczeństwie na platformie Kakobuy. Jak weryfikować sprzedawców, sprawdzać zdjęcia QC i unikać potencjalnych oszustw.",
    article2Title: "Najlepsze Sneakersy w Kakobuy Spreadsheet 2026",
    article2Desc: "Odkryj topowe modele sneakersów dostępne w Kakobuy Spreadsheet. Nike, Jordan, Adidas, New Balance i wiele więcej w jednym miejscu.",
    article3Title: "Kakobuy dla początkujących – Wszystko co musisz wiedzieć",
    article3Desc: "Kompletny przewodnik dla osób rozpoczynających przygodę z Kakobuy. Od rejestracji przez pierwsze zamówienie aż po odbiór paczki.",
    article4Title: "Streetwear na Kakobuy – Kompletny przewodnik po stylu ulicznym",
    article4Desc: "Jak znaleźć najlepsze ubrania streetwearowe na Kakobuy. Bluzy, koszulki, kurtki i akcesoria inspirowane światowymi trendami.",
    article5Title: "Kakobuy Spreadsheet Shoes – Najlepsze buty w jednym miejscu",
    article5Desc: "Przegląd najlepszych modeli butów dostępnych w arkuszu. Porównanie jakości, cen i sprzedawców dla każdej popularnej marki.",
    article6Title: "Kakobuy Spreadsheet Clothes – Moda na wyciągnięcie ręki",
    article6Desc: "Kompletny przegląd odzieży w Kakobuy Spreadsheet. Od codziennych stylizacji po ekskluzywne ubrania w przystępnych cenach.",
    article7Title: "Kakobuy vs inne platformy – Porównanie i analiza",
    article7Desc: "Szczegółowe porównanie Kakobuy z innymi popularnymi platformami zakupowymi. Zalety, wady i rekomendacje dla polskich kupujących.",
    article8Title: "Jak znaleźć najlepsze okazje w Kakobuy Spreadsheet",
    article8Desc: "Praktyczne wskazówki i triki pomagające znaleźć ukryte perełki produktowe. Oszczędzaj pieniądze dzięki sprawdzonym metodom wyszukiwania.",
    article9Title: "Kakobuy Spreadsheet Akcesoria – Torby, paski i dodatki",
    article9Desc: "Przegląd akcesoriów dostępnych w Kakobuy Spreadsheet. Torby, paski, portfele i biżuteria inspirowana markami premium w atrakcyjnych cenach.",
  },
  faq: {
    title: "Często Zadawane Pytania",
    q1: "Czym dokładnie jest Kakobuy Spreadsheet?",
    a1: "Kakobuy Spreadsheet to starannie przygotowany arkusz kalkulacyjny zawierający setki linków do najlepszych produktów dostępnych na platformie Kakobuy. Zawiera on kategorie takie jak buty, odzież, akcesoria i wiele więcej, wraz z ocenami jakości i rekomendacjami społeczności.",
    q2: "Czy korzystanie z Kakobuy Spreadsheet jest darmowe?",
    a2: "Tak, nasz Kakobuy Spreadsheet jest całkowicie darmowy. Udostępniamy go jako narzędzie pomocnicze dla społeczności, aby ułatwić wyszukiwanie najlepszych produktów na platformie Kakobuy.",
    q3: "Jak często aktualizowany jest arkusz?",
    a3: "Arkusz jest regularnie aktualizowany, aby zapewnić dostęp do najnowszych i najbardziej aktualnych linków do produktów. Nowe znaleziska są dodawane, a nieaktualne linki są usuwane na bieżąco.",
    q4: "Czy mogę ufać produktom z arkusza?",
    a4: "Wszystkie produkty w arkuszu zostały zweryfikowane przez społeczność. Zawsze jednak zalecamy sprawdzenie ocen sprzedawcy, poproszenie o zdjęcia QC oraz dokładne przeczytanie opisów produktów przed dokonaniem zakupu.",
    q5: "Jakie kategorie produktów zawiera arkusz?",
    a5: "Arkusz zawiera szeroki wybór kategorii, w tym buty (sneakersy), odzież (bluzy, koszulki, kurtki, spodnie), akcesoria (torby, paski, czapki), perfumy, bieliznę oraz wiele innych kategorii produktowych.",
    q6: "Czy Kakobuy Spreadsheet działa w Polsce?",
    a6: "Tak, Kakobuy Spreadsheet jest w pełni dostępny dla użytkowników z Polski. Platforma Kakobuy obsługuje wysyłkę do Polski, a nasz arkusz jest zoptymalizowany pod kątem polskich użytkowników i ich preferencji zakupowych.",
  },
  footer: {
    description: "kakobuypolska.site to niezależne źródło informacji o Kakobuy Spreadsheet. Nie jesteśmy oficjalnie powiązani z platformą Kakobuy. Naszym celem jest dostarczanie wartościowych informacji i ułatwianie zakupów online.",
    quickLinks: "Szybkie Linki",
    categories: "Kategorie",
    disclaimer: "Strona kakobuypolska.site jest niezależnym źródłem informacji i nie jest oficjalnie powiązana z Kakobuy.",
    copyright: "© 2026 kakobuypolska.site. Wszelkie prawa zastrzeżone.",
  },
};

export default translation;